import {ERROR_LINE, RESET_LINE_ERROR} from "../actions/Line";

const defaultState = {
    error: null,
    hasError: false
};

const KirokuAILine = (state = defaultState, action) => {
    switch (action.type) {
        case ERROR_LINE :
            return {
                ...state,
                ...action.error
            };
        case RESET_LINE_ERROR :
            return {
                error: null,
                hasError: false
            };
        default :
            return state;
    }
};

export default KirokuAILine;
